import React, { useState } from "react";

export default function WeatherTemperature(props) {
  const [unit, setUnit] = useState("celsius");

  function showFahrenheit(event) {
    event.preventDefault();
    setUnit("fahrenheit");
  }

  function showCelsius(event) {
    event.preventDefault();
    setUnit("celsius");
  }

  if (unit === "celsius") {
    return (
      <div className="weatherTemperature">
        <span className="temperature">{Math.round(props.celsuis)}°C</span>

        <span className="unit">
          <a href="/" onClick={showFahrenheit}>
            ℃
          </a>{" "}
          | °F
        </span>
      </div>
    );
  } else {
    let fahrenheit = (props.celsuis * 9) / 5 + 32;

    return (
      <div className="weatherTemperature">
        <span className="temperature">{Math.round(fahrenheit)}°F</span>

        <span className="unit">
          <a href="/" onClick={showCelsius}>
            °C
          </a>{" "}
          | °F
        </span>
      </div>
    );
  }
}
